import { useSetModal } from "@/shared/atoms/useModal";
import usePosOrderCurrentAction, {
  CurrentActionTypes,
} from "@/shared/atoms/usePosOrderCurrentAction";
import { useAddCartItem } from "@/shared/hooks/useCartHook";
import {
  useHasSession,
  useShowPayments,
} from "@/shared/hooks/usePosOrderTableSessionHook";
import { getRandomNegativeId } from "@/shared/utils/helpers";
import { useTranslation } from "react-i18next";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import useActionClick from "./useActionClick";
import useVatHook from "@/shared/hooks/useVatHook";

export const useCustomProductAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const [currentAction] = usePosOrderCurrentAction();
  const hasSession = useHasSession();
  const showPayments = useShowPayments();
  const addCartItem = useAddCartItem();
  const setModal = useSetModal();
  const { vats } = useVatHook();

  return {
    name: "customProduct" as CurrentActionTypes,
    label: t("posOrders.addCustomProduct"),
    set: (price) => {
      const cartItem = {
        price: price,
        description: "",
        vat_percentage: vats[1].percentage,
        name: t("posOrders.openProduct"),
        item_id: getRandomNegativeId(),
        quantity: 1,
      };
      if (currentAction?.name === "customProduct" && price === undefined) {
        setModal("posOrderProduct", { product: cartItem });
      } else if (price) {
        addCartItem(cartItem);
      }
    },
    instantSet: true,
    filtered: false,
    disabled: hasSession ? showPayments : false,
    iconVariant: "plus",
  };
};

const CustomProductAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useCustomProductAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default CustomProductAction;
